import React, { useState } from 'react';
import { Lock, LogIn } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const CleaningLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const API = process.env.REACT_APP_BACKEND_URL || '';
      const res = await fetch(`${API}/api/cleaning/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.detail || 'Login failed');
      }
      const user = await res.json();
      sessionStorage.setItem('cleaning_token', user.token);
      onLogin(user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F9F9] flex items-center justify-center px-4" data-testid="cleaning-login">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-lg border border-[#E2E8F0] w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="w-14 h-14 bg-[#65c3ba] rounded-full flex items-center justify-center mx-auto mb-3">
            <Lock className="text-white" size={24} />
          </div>
          <h1 className="text-xl font-bold text-[#0A1312]" style={{fontFamily: "'Cabinet Grotesk', sans-serif"}}>Homewise Cleaning</h1>
          <p className="text-sm text-[#0A1312]/60 mt-1">Area riservata al team operativo</p>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="text-sm text-[#0A1312]">Email</Label>
            <Input type="email" value={email} onChange={e => setEmail(e.target.value)} data-testid="cleaning-email" className="mt-1" required />
          </div>
          <div>
            <Label className="text-sm text-[#0A1312]">Password</Label>
            <Input type="password" value={password} onChange={e => setPassword(e.target.value)} data-testid="cleaning-password" className="mt-1" required />
          </div>
          {error && <p className="text-red-500 text-sm">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-[#65c3ba] text-white hover:bg-[#3e716c]" data-testid="cleaning-login-btn">
            <LogIn size={16} className="mr-2" />{loading ? 'Accesso...' : 'Accedi'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CleaningLogin;
